export default __webpack_public_path__ + "5594c6b9f44b59357313e419713c005e.ico";